var CardSlider = function(){

	var comp = $('[data-component="card-slider"]');

	this.init = function(){

		initSliderBanner();

		initSliderSmallCard();

	}

	function initSliderBanner(){
		comp.find('.slider.banner').slick({
			infinite: false,
			dots: true
		})
	}

	function initSliderSmallCard() {
		comp.find('.slider.small-card').slick({
			infinite: true,
			dots: false
		})
	}

	return this.init();

}
